/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EdictSource = {
    Edikt: 'Edikt',
    Ozufs: 'Ozufs'
} as const;
export type EdictSource = typeof EdictSource[keyof typeof EdictSource];


export function instanceOfEdictSource(value: any): boolean {
    for (const key in EdictSource) {
        if (Object.prototype.hasOwnProperty.call(EdictSource, key)) {
            if (EdictSource[key as keyof typeof EdictSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EdictSourceFromJSON(json: any): EdictSource {
    return EdictSourceFromJSONTyped(json, false);
}

export function EdictSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictSource {
    return json as EdictSource;
}

export function EdictSourceToJSON(value?: EdictSource | null): any {
    return value as any;
}

export function EdictSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): EdictSource {
    return value as EdictSource;
}

